import { createActions, createReducer } from 'reduxsauce'

import ConsultaAdiantamentosSuprimentosService from '../../servicos/ConsultaAdiantamentosSuprimentosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaAdiantamentosSuprimentosInicio: [],
    buscaConsultaAdiantamentosSuprimentosErro: ['erro'],
    buscaConsultaAdiantamentosSuprimentosSucesso: ['consultaAdiantamentosSuprimentos'],
    limpar: [],
    setConsultaAdiantamentosSuprimentosEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaAdiantamentosSuprimentos = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaAdiantamentosSuprimentosInicio())
        let serv = new ConsultaAdiantamentosSuprimentosService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaAdiantamentosSuprimentosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaAdiantamentosSuprimentosErro(error)))
    }
}

const buscaConsultaAdiantamentosSuprimentosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaAdiantamentosSuprimentosErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaAdiantamentosSuprimentosSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaAdiantamentosSuprimentos.resultado,
        dataSincronizacaoDados: action.consultaAdiantamentosSuprimentos.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaAdiantamentosSuprimentosEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS_INICIO]: buscaConsultaAdiantamentosSuprimentosInicio,
    [Types.BUSCA_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS_ERRO]: buscaConsultaAdiantamentosSuprimentosErro,
    [Types.BUSCA_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS_SUCESSO]: buscaConsultaAdiantamentosSuprimentosSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS_ESTADO_DT]: setConsultaAdiantamentosSuprimentosEstadoDT,
})
